module.exports = __webpack_public_path__ + "static/media/devops.62b9f892.png";